/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelSlider64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelSlider64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g opacity="0.22">
            <path
              d="M32 47.5C32.8284 47.5 33.5 46.8284 33.5 46C33.5 45.1716 32.8284 44.5 32 44.5C31.1716 44.5 30.5 45.1716 30.5 46C30.5 46.8284 31.1716 47.5 32 47.5Z"
              fill="currentColor"
            />
            <path
              d="M38 47.5C38.8284 47.5 39.5 46.8284 39.5 46C39.5 45.1716 38.8284 44.5 38 44.5C37.1716 44.5 36.5 45.1716 36.5 46C36.5 46.8284 37.1716 47.5 38 47.5Z"
              fill="currentColor"
            />
          </g>
          <g>
            <path
              d="M26 47.5C26.8284 47.5 27.5 46.8284 27.5 46C27.5 45.1716 26.8284 44.5 26 44.5C25.1716 44.5 24.5 45.1716 24.5 46C24.5 46.8284 25.1716 47.5 26 47.5Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 16C8 13.7909 9.79086 12 12 12H52C54.2091 12 56 13.7909 56 16V48C56 50.2091 54.2091 52 52 52H12C9.79086 52 8 50.2091 8 48V16ZM12 13H52C53.6569 13 55 14.3431 55 16V48C55 49.6569 53.6569 51 52 51H12C10.3431 51 9 49.6569 9 48V16C9 14.3431 10.3431 13 12 13Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelSlider64Icon.tags = [
  'slider',
  'panel',
  'dots',
  'navigation',
  'interface',
];

AddPanelSlider64Icon.category = '64x64 (Add panel)';

AddPanelSlider64Icon.iconSize = 64;
